import { Label } from 'app/design/icons/label';
import { Column, Row } from 'app/design/primitives/box';
import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import type { SharingPlaceDiscount } from 'app/types/sharing-place';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

interface Properties {
  open: boolean;
  onClose: () => void;
  discount?: SharingPlaceDiscount;
}

export function DiscountDetailBottomSheet({ open, onClose, discount }: Properties) {
  const { t } = useTranslation();

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      showIndicator={false}
      CustomHeaderComponent={
        <Row
          alignItems="center"
          justifyContent="center"
          style={{
            borderTopLeftRadius: theme.borderRadii['radius.xl'],
            borderTopRightRadius: theme.borderRadii['radius.xl'],
            paddingVertical: theme.spacing['spacing.general.x4'],
            paddingHorizontal: theme.spacing['spacing.general.x5'],
            position: 'relative',
            width: '100%',
          }}
        >
          <Text fontWeight="700" variant="bodyLarge" textAlign="center">
            {t('discount.sheetTitle', { ns: 'neighbour-profile' })}
          </Text>
          <Button
            accessibilityLabel={t('close', { ns: 'accessibility' })}
            hitSlop={20}
            onPress={onClose}
            variant="plain"
            style={{
              position: 'absolute',
              left: theme.spacing['spacing.general.x2'],
              padding: theme.spacing['spacing.general.x1'],
            }}
          >
            <IconX strokeWidth={ICON_STROKE_WIDTH} size={24} color={theme.colors['text.primary']} />
          </Button>
        </Row>
      }
    >
      <Column style={{ paddingBottom: theme.spacing['spacing.general.x12'] }}>
        {/* Banner */}
        <Column
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: '#FAD4D2',
            marginHorizontal: theme.spacing['spacing.general.x5'],
            borderRadius: theme.borderRadii['radius.lg'],
            height: 148,
            marginBottom: theme.spacing['spacing.general.x4'],
          }}
        >
          <Label color={theme.colors['surface.error.default']} width={86} height={86} />
        </Column>

        <Column style={{ paddingHorizontal: theme.spacing['spacing.general.x5'] }} gap="spacing.general.x2">
          {discount?.subTitle ? (
            <Text fontWeight="700" variant="headerXSmall">
              {discount.subTitle}
            </Text>
          ) : null}
          {discount?.description ? (
            <Text variant="bodyBase" color="text.primary">
              {discount.description}
            </Text>
          ) : null}
        </Column>
      </Column>
    </BottomSheet>
  );
}
